"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PILL_VARIANTS = void 0;

var _themeGet = require("@styled-system/theme-get");

var _styledComponents = require("styled-components");

var _shadow = require("../../helpers/shadow");

var PILL_VARIANTS = {
  textRound: {
    default: (0, _styledComponents.css)(["border-radius:15px;height:30px;padding:0 ", ";"], (0, _themeGet.themeGet)("space.1")),
    hover: (0, _styledComponents.css)(["background-color:transparent;border-color:transparent;box-shadow:", ";color:", ";"], _shadow.DROP_SHADOW, (0, _themeGet.themeGet)("colors.brand")),
    focus: (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black5"), (0, _themeGet.themeGet)("colors.brand")),
    active: (0, _styledComponents.css)(["background-color:transparent;border-color:", ";"], (0, _themeGet.themeGet)("colors.black60"))
  },
  textSquare: {
    default: (0, _styledComponents.css)(["height:30px;padding:0 ", ";"], (0, _themeGet.themeGet)("space.1")),
    hover: (0, _styledComponents.css)(["background-color:transparent;border-color:transparent;box-shadow:", ";color:", ";"], _shadow.DROP_SHADOW, (0, _themeGet.themeGet)("colors.brand")),
    focus: (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black5"), (0, _themeGet.themeGet)("colors.brand")),
    active: (0, _styledComponents.css)(["background-color:transparent;border-color:", ";"], (0, _themeGet.themeGet)("colors.black60"))
  },
  filter: {
    default: (0, _styledComponents.css)(["border-radius:20px;height:40px;padding:0 ", ";"], (0, _themeGet.themeGet)("space.2")),
    hover: (0, _styledComponents.css)(["background-color:transparent;border-color:transparent;box-shadow:", ";color:", ";"], _shadow.DROP_SHADOW, (0, _themeGet.themeGet)("colors.brand")),
    focus: (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black5"), (0, _themeGet.themeGet)("colors.brand")),
    active: (0, _styledComponents.css)(["background-color:transparent;border-color:", ";"], (0, _themeGet.themeGet)("colors.black60"))
  },
  artist: {
    default: (0, _styledComponents.css)(["border-radius:25px;height:50px;padding:0 ", " 0 ", ";"], (0, _themeGet.themeGet)("space.2"), (0, _themeGet.themeGet)("space.1")),
    hover: (0, _styledComponents.css)(["background-color:transparent;border-color:transparent;box-shadow:", ";"], _shadow.DROP_SHADOW),
    focus: (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.black5"), (0, _themeGet.themeGet)("colors.brand")),
    active: (0, _styledComponents.css)([""]) // Not used

  }
};
exports.PILL_VARIANTS = PILL_VARIANTS;
//# sourceMappingURL=tokens.js.map